module.exports = __webpack_public_path__ + "static/logistic-growth_fr-65d7a5bc7acc70eab43ec8929313c8bb.svg";